<template>
    <div class="history-detail">
        <div class="row">
            <div class="col-12">
                <Loading v-if="isLoading"></Loading>
                <template v-else-if="historyData.length === 0">
                    <div class="row empty-data">
                        <h3 class="text-center m-0">
                            {{ getTranslatedText(`no data`) }}
                        </h3>
                    </div>
                </template>
                <template v-else>
                    <HistoryTable :history-data="historyData" />
                    <Pagination v-if="totalPages > 1" :current-page="currentPage" :total-pages="totalPages"
                        @change-page="handlePageChange" />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import utilMixins from "@/mixins/utils/utils-mixins";
import Loading from "@/components/common/loading.vue";
import HistoryTable from "@/components/history/components/HistoryTable.vue";
import Pagination from "@/components/common/Pagination.vue";
import historyService from "@/services/history/index.service";

export default {
    name: 'HistoryDetail',
    components: { Loading, HistoryTable, Pagination },
    mixins: [languageMixins, utilMixins],
    props: {
        transactionId: {
            type: String,
            required: true
        },
        startDate: {
            type: String,
            required: true
        },
        endDate: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            currentPage: 1,
            isLoading: false,
            totalPages: 1,
            historyData: []
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.isLoading = true;
            let payload = {
                limit: 10,
                current_page: this.currentPage,
                transactionId: this.transactionId,
                from_date: this.startDate,
                to_date: this.endDate,
                status: this.status
            }
            try {
                const response = await historyService.getHistory(payload);
                this.historyData = response.data;
                this.totalPages = response.paginator?.total_pages || 1;
            } catch (error) {
                console.error('Error fetching history data:', error);
            } finally {
                this.isLoading = false;
            }
        },

        handlePageChange(page) {
            this.currentPage = page;
            this.fetchData();
        },
    }
}
</script>

<style lang="scss">
@import "@/public/scss/history.scss";
</style>